// extracted by mini-css-extract-plugin
export default {"container":"previousBill_container__TXqXh","noBills":"previousBill_noBills__5hevp"};